import { TransactionDto } from '@unistocks/proxy/axios-client';

export const externalTransactionDate = 'ExternalTransactionDate';
export const externalTransactionProvider = 'ExternalTransactionProvider';

export const isExternalTransaction = (transaction: TransactionDto) =>
  !!transaction.extraProperties?.[externalTransactionDate] &&
  !!transaction.extraProperties?.[externalTransactionProvider];
